/* eslint-disable @typescript-eslint/no-unused-vars */
import * as X from "@/ui";



import { useTravelerHomePage } from "@/providers/strapi/content/types/singleTypes/traveler-home-page";
import { Testimonial, RatingCard, TestimonialSlide } from "@/providers/strapi/content/types/components/traveler.component";
import ReactMarkdown from "react-markdown";
import { StaticImageData } from "next/image";


// const defaultData = {
//   title: {
//     en: <>Our customers<br /><strong>say it best!</strong></>,
//     fr: <>Vous en parlez<br /><strong>mieux que nous{X.Nbsp}!</strong></>,
//   },

//   subtitle: {
//     en: <>Join 150,000 satisfied travelers (and counting)</>,
//     fr: <>Nous comptons déjà 150.000 voyageurs satisfaits</>,
//   },

//   cta: {
//     en: "Download the app",
//     fr: "Téléchargez l'application",
//   },

//   testimonials: [
//     {
//       photo: PhotoQuentinM,
//       name: {
//         en: "Quentin M.",
//         fr: "Quentin M.",
//       },
//       text: {
//         en: "",
//         fr: ""
//         // en: ["I was skeptical at first, but Zapptax exceeded my expectations. The process was smooth and I received my refund faster than expected. Will definitely use again!"],
//         // fr: [
//         //   `Vivant à l’étranger depuis près de 10 ans, je peux affirmer que Zapptax à transformé mon expérience détaxe depuis que j’ai commencé à l’utiliser il y a environ 5 ans. Zapptax est beaucoup plus pratique que les opérateurs traditionnels, (beaucoup) moins cher, et leur service support est ultra réactif, 7/7j et 24/22h.`,
//         //   `L’appli est simple d’utilisation, la paperasse avec les douanes est automatiqée, et Zapptax autorise l’enregistrement d’achats de moindre valeurs que les autres opérateurs.`,
//         //   `Par dessus le marché, ils sont rapides à rembourser.`,
//         //   `Que demander d’autre${X.Nbsp}?`,
//         // ],
//       },
//     },
//     // {
//     //   name: {
//     //     en: "Diane W.",
//     //     fr: "Diane W.",
//     //   },
//     //   photo: PhotoDianeW,
//     //   text: {
//     //     en: ["Excellent idea and team. Definitely removing a big hassle if you have to do it yourself. Very responsive team. Very good communication always keeping you posted of status along the way. Highly recommend."],
//     //     fr: ["Excellente idée et excellente équipe. Cela enlève vraiment un gros tracas si vous devez le faire vous-même. Équipe très réactive. Très bonne communication, avec des mises à jour régulières tout au long du processus. Je recommande vivement."],
//     //   },
//     // },
//     // {
//     //   name: {
//     //     en: "Mia T.",
//     //     fr: "Mia T.",
//     //   },
//     //   photo: PhotoMiaT,
//     //   text: {
//     //     en: ["A bit of stress when finalizing my tax refund, but the Zapptax team was incredibly responsive. They guided me quickly and everything was sorted out smoothly. I received my refund as expected. Reliable and efficient service — I definitely recommend it!"],
//     //     fr: [`Petit stress au moment de valider ma détaxe, mais l’équipe de Zapptax a été incroyablement réactive. Ils m’ont guidée rapidement et tout s’est réglé sans problème. Remboursement reçu comme prévu. Un service fiable et efficace, je recommande${X.Nbsp}!`],
//     //   },
//     // },
//   ],
// };

type ViewModel = {
  // rating: {
  //   title: string;
  //   subtitle: string;
  // },
  testimonials: {
    cta: string;
    slides: Array<{
      photo: StaticImageData;
      name: string;
      text: string;
    }>
  }

}

// const buildData = (testimonial: Testimonial, rating: RatingCard): ViewModel => ({
//   // rating: {
//   //   title: rating.hiddableTitle,
//   //   subtitle: rating.title
//   // },


//   // <ReactMarkdown components={{
//   //   h4: ({ ...props }) => <span {...props} />,
//   //   strong: ({ ...props }) => <strong {...props} className="font-medium" />,
//   // }}>
//   //   {rating.hiddableTitle}
//   // </ReactMarkdown>,



//   //subtitle: {
//   //   en: <ReactMarkdown components={{
//   //     p: ({ ...props }) => <span {...props} />,
//   //     strong: ({ ...props }) => <strong {...props} className="font-medium" />,
//   //   }}>
//   //     {rating.title}
//   //   </ReactMarkdown>,
//   //   fr: <ReactMarkdown components={{
//   //     p: ({ ...props }) => <span {...props} />,
//   //     strong: ({ ...props }) => <strong {...props} className="font-medium" />,
//   //   }}>
//   //     {rating.title}
//   //   </ReactMarkdown>
//   //   // en: "Join 150,000 satisfied travelers (and counting)",
//   //   // fr: "Nous comptons déjà 150.000 voyageurs satisfaits",
//   // },

//   testimonials: {
//     cta: testimonial.cta,
//     slides: testimonial.testimonialSlides.map((t) => ({
//       photo: PhotoQuentinM,
//       name: t.name,
//       text: t.content
//     }))
//   }


//   // [
//   //   {
//   //     photo: PhotoQuentinM,
//   //     name: {
//   //       en: "Quentin M.",
//   //       fr: "Quentin M.",
//   //     },
//   //     text: {
//   //       en: ["I was skeptical at first, but Zapptax exceeded my expectations. The process was smooth and I received my refund faster than expected. Will definitely use again!"],
//   //       fr: [
//   //         `Vivant à l’étranger depuis près de 10 ans, je peux affirmer que Zapptax à transformé mon expérience détaxe depuis que j’ai commencé à l’utiliser il y a environ 5 ans. Zapptax est beaucoup plus pratique que les opérateurs traditionnels, (beaucoup) moins cher, et leur service support est ultra réactif, 7/7j et 24/22h.`,
//   //         `L’appli est simple d’utilisation, la paperasse avec les douanes est automatiqée, et Zapptax autorise l’enregistrement d’achats de moindre valeurs que les autres opérateurs.`,
//   //         `Par dessus le marché, ils sont rapides à rembourser.`,
//   //         `Que demander d’autre${X.Nbsp}?`,
//   //       ],
//   //     },
//   //   },
//   //   {
//   //     name: {
//   //       en: "Diane W.",
//   //       fr: "Diane W.",
//   //     },
//   //     photo: PhotoDianeW,
//   //     text: {
//   //       en: ["Excellent idea and team. Definitely removing a big hassle if you have to do it yourself. Very responsive team. Very good communication always keeping you posted of status along the way. Highly recommend."],
//   //       fr: ["Excellente idée et excellente équipe. Cela enlève vraiment un gros tracas si vous devez le faire vous-même. Équipe très réactive. Très bonne communication, avec des mises à jour régulières tout au long du processus. Je recommande vivement."],
//   //     },
//   //   },
//   //   {
//   //     name: {
//   //       en: "Mia T.",
//   //       fr: "Mia T.",
//   //     },
//   //     photo: PhotoMiaT,
//   //     text: {
//   //       en: ["A bit of stress when finalizing my tax refund, but the Zapptax team was incredibly responsive. They guided me quickly and everything was sorted out smoothly. I received my refund as expected. Reliable and efficient service — I definitely recommend it!"],
//   //       fr: [`Petit stress au moment de valider ma détaxe, mais l’équipe de Zapptax a été incroyablement réactive. Ils m’ont guidée rapidement et tout s’est réglé sans problème. Remboursement reçu comme prévu. Un service fiable et efficace, je recommande${X.Nbsp}!`],
//   //     },
//   //   },
//   // ],
// });


export function TestimonialsSection(props: X.PageProps<{
  onDownloadApp?: () => void;
}>) {
  // const tr = X.useTranslator();
  const downloadUrl = X.useDownloadUrl(props.locale);
  const testimonial = useTravelerHomePage('testimonial');
  const ratingCard = useTravelerHomePage('testimonialRatingCard');
  // const viewModel = buildData(testimonial, ratingCard);

  return (
    <X.TestimonialsSection
      id="testimonials"
      // title={data.title}
      // subtitle={data.subtitle}
      testimonials={testimonial.testimonialSlides}
      className="xl:my-20 xl:mb-24"
      locale={props.locale}
      ratingCard={ratingCard}
      cta={props.onDownloadApp ? {
        mobile: (
          <X.Button
            primary lg
            exitHref={downloadUrl}
            // label={tr(data.tes)}
            label={testimonial.cta}
          />
        ),
        desktop: (
          <X.Button
            primary lg
            onClick={props.onDownloadApp}
            // label={tr(data.cta)}
            label={testimonial.cta}
          />
        ),
      } : undefined}
    />
  );
}
